import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
declare var app;
@Component({
  selector: 'app-mz-grid-list-leave',
  templateUrl: './mz-grid-list-leave.component.html',
  styleUrls: ['./mz-grid-list-leave.component.scss']
})
export class MzGridListLeaveComponent extends GridBaseCase {
  month: any = new Date();
  searchDate = null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量

  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase
  ) { super(); 
     /**
     * 设置默认当前年月
     */
    const _date = new Date();
    const _month = _date.getMonth() + 1;
    this.month = _date.getFullYear() + "-" + (_month < 10 ? ("0" + _month) : _month)+"-01";
  }

  // ngOnInit() {
  // }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
      // console.log(that.month);
      if (!that.searchDate) {
        let nowyear: any = that.com.getNow.split('-')[0];
        let nowmonth: any = that.com.getNow.split('-')[1];
        let startDate = nowyear + "-" + nowmonth + "-" + "01" + " 00:00:00";
        let day = new Date(nowyear, nowmonth, 0);
        let endDate = nowyear + "-" + nowmonth + "-" + day.getDate() + " 23:59:59";
        that.searchDate = that.com.BetweenDate(startDate, endDate);
      }
      //请假列表
      if (that.searchDate) {
        body.RequestBody = JSON.stringify({ "a_FK_SystemUser_ID": that.com.GetAccount.Id, "a_ModifyTime": that.searchDate });
      } else {
        body.RequestBody = JSON.stringify({ "a_FK_SystemUser_ID": that.com.GetAccount.Id, "a_ModifyTime": that.searchDate });
      }
      // if(that.baseService.storeSearch.name){

      //   body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id,"a_name":that.baseService.storeSearch.name});
      // }else{
      //   body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id});
      // }
      // body.RequestBody= JSON.stringify({"store_FK_SystemUser_ID":that.com.GetAccount.Id});
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          // console.log(that.dataArrayList);
        });
         /****上拉加载数据begin****/
         that.RecordCount = data.Status.RecordCount;
         if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
           that.infiniteScroll.disabled = true;
         } else {
           that.infiniteScroll.disabled = false;
         }
         /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    })
  }
  changeMonth(type, $event:any = "") {
    const that=this;
    let t = type;
    let current = new Date(this.month);
    let current_year = null;
    let current_month = null;
    if (t == 'pre') {
      current_year = current.getFullYear();
      current_month = this.getmonth(current.getMonth());
    } else if (t == 'next') {
      if((current.getMonth()+2)>12){
        current_year = current.getFullYear()+1;
        current_month = "01";
      }else{
        current_year = current.getFullYear();
        current_month = that.getmonth(current.getMonth() + 2);
      }

    } else if (t == 'datetime') {
      // console.log($event.detail.value);
      current_year = $event.detail.value.split("-")[0];
      current_month = $event.detail.value.split("-")[1];
    }

    if (current_month == 13) {
      current_year += 1;
      current_month = 1;
    } else if (current_month == 0) {
      current_year -= 1;
      current_month = 12;
    }
    //获取月份对应的天数
    let d = new Date(current_year, current_month, 0);
    // console.log(d.getDate());

    let startmonthDay = current_year + "-" + current_month + "-" + "01 00:00:00";
    let endmonthDay = current_year + "-" + current_month + "-" + d.getDate() + " 23:59:59";
    this.searchDate = this.com.BetweenDate(startmonthDay, endmonthDay);
    this.month = current_year + '-' + current_month;
    if (t == 'datetime') {
      this.LoadData(1);
    }
  }

  EventLink(ev: any, parms: any) {
    let evs = ev.url || '';
    // console.log(evs, parms);
    if (evs.trim() && parms) {
      if (evs.indexOf("http") > 0) {
        this.com.goWebPage(evs, '详情');
      } else {
        this.com.setHistoryUrl();
        // this.router.navigateByUrl(evs + "/GETEDITE/" + parms.id.value+"&"+this.com.getNowDatetime);
        this.com.Go(evs + "/GETEDITE/" + parms.id.value+"&"+this.com.getNowDatetime);
      }
    }
  }
  getmonth(month: Number) {
    let months: any = month;
    if (month < 10) {
      months = "0" + month
    }
    return months;
  }

}
